module.exports = __webpack_public_path__ + "h5/img/head5.42d859fd.png";